/**
 * Authentication API Module
 * Handles user authentication endpoints
 * Part of API optimization - follows AIM atomicity principle
 */

import { api } from './client'
import { longRunningClient } from '../apiClient'

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => api.post('/auth/logout'),
  refresh: (token) => api.post('/auth/refresh', { token }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  getProfile: () => api.get('/profile', { 
    silentAuth: true,
    noRetry: true,
    validateStatus: (status) => {
      // Treat 401 as valid response (user not logged in is expected)
      return status >= 200 && status < 300 || status === 401 || status === 500
    }
  }),
  updateProfile: (data) => api.put('/profile', data),
  uploadImage: (formData) => longRunningClient.post('/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }),
  googleAuth: () => api.get('/auth/google'),
  googleCallback: (code, state, language) => api.get(`/auth/google/callback?code=${code}&state=${state}${language ? `&language=${language}` : ''}`),
  getReferralInfo: () => api.get('/profile/referral'),
}
